module.exports = __webpack_public_path__ + "assets/bg_aboutus_02.32643ffe.svg";